/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const deleteDependencyRestRequestSchema = z.object({
  predecessorId: z.int().nullish(),
  successorId: z.int().nullish(),
});
